module.exports = __webpack_public_path__ + "img/bottom-right-top-right.1c9b160b.jpg";